import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LogQueryDetails } from "./components/LogQueryDetails";

export function LogQueryPage() {
  return (
    <Page title="Query Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogQueryDetails />
      </Container>
    </Page>
  );
}
